import { marked } from 'marked';

/**
 * Converts markdown text to HTML.
 *
 * @example
 *   markdownToHtml('**foo**'); // <b>foo</b>
 *
 * @param text The markdown text.
 */
export function markdownToHtml(text: string): string {
  return marked.parse(text, {
    gfm: true,
    breaks: true,
    mangle: false,
  });
}
